import AppHeaderArtwork, { AppHeaderArtworkProps } from './AppHeaderArtwork';

export default AppHeaderArtwork;
export type { AppHeaderArtworkProps };
